import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './global.css';
import Shell from './apps/home/App';
import { loadPlatformCapabilities } from './shared/platform/apps';

// 平台启动时装载能力清单（各 app 向平台注册跨 app 能力，
// 如 notebook 右键查词用的 dictionary.lookup）
loadPlatformCapabilities();

// home 应用即 OS 外壳：左侧 dock + 右侧应用面板。
// 各子应用（notebook / ledger）由外壳按当前路径懒加载挂载，
// 与 server 端的 SPA fallback 配合，任意路径刷新都能恢复到对应应用。
const rootEl = document.getElementById('root');
if (rootEl) {
  createRoot(rootEl).render(
    <StrictMode>
      <Shell />
    </StrictMode>,
  );
}
